import Vue from 'vue'

export default {
    getProjects(urlParamProject=null){
        if (urlParamProject==0) urlParamProject=null              
        return new Promise((resolve, reject) =>{
            
            let selectedIndex=null
            
            Vue.prototype.$apiService.get('projects').then((res)=>{  
                   
                if(typeof(res.response)=="undefined"){
                    resolve(false)
                    return
                } 
                res.response.data.forEach(function(singleproject,index) {                                          
                    //priorità

                    // parametro get                                        
                    if (urlParamProject!=null && singleproject.id == urlParamProject){
                        selectedIndex = index                                                          
                                                
                    // local session    
                    }else if(selectedIndex==null && JSON.parse(localStorage.getItem('lastProjectSelected'))!=null && singleproject.id ==JSON.parse(localStorage.getItem('lastProjectSelected')).id){
                        selectedIndex = index                                                
                        
                    }

                }.bind(this))  

                if (selectedIndex==null) selectedIndex=0                
                res.response.data[selectedIndex].selected=true
                var projectlist = res
                this.setCurrentProject(res.response.data[selectedIndex]).then((res)=>{
                    resolve(projectlist);
                })                            

            })

        })    
    },
    
    setCurrentProject(project){
        return new Promise((resolve, reject) =>{                    
            localStorage.setItem('lastProjectSelected', JSON.stringify(project))   
            resolve(true)            
        })

    },

}